// TODO: Replace all string appereances with these dateFormats for consistency and maintaince
export const DATE_FORMATS = {
  COMMENT: 'ddd MM/DD h:mm a',
  STANDARD: 'YYYY-MM-DD',
  MEDIUM: 'MMM D, YYYY',
  DAY: 'ddd MM/DD',
  MONTH: 'MMMM',
  SHORT: 'MM/DD/YYYY',
  ACTIVE: 'M/DD [at] h:mm a',
  CUSTOM: 'HH:mm - MMMM D YYYY'
};
